export default __webpack_public_path__ + "static/media/phase2_cover.00915eac.jpg";